<template>
  <div class="invoice">
    <van-tabs v-model="active" sticky @change="openKeyFg">
      <van-tab v-for="(item,index) in tabs" :title="item.name" :key="index">
        <van-list
          v-model="loading"
          :finished="finished"
          :finished-text="invoiceListMy.length > 0 ? '没有更多了' : ''"
          @load="moreLadFg"
        >
          <div v-if="index == 0 && active == 0">
            <div class="n_tips">
              <p>1.确认收货后7日后可申请发票，申请开票后将不能退货！</p>
              <p>2.只提供最近12个月内完成的订单开具发票，请知悉！</p>
            </div>
            <invoiceOrder @allCheckFg="allCheckFg" :invoiceList="invoiceListOrder"></invoiceOrder>
          </div>
          <div v-if="index == 20">
            <invoice-hb :invoiceList="invoiceListRitual"></invoice-hb>
          </div>
          <div v-if="index == 1">
            <div class="invoice-scroll">
              <span>开票状态 {{status == 0 ? '全部' : status == 1 ? '开票中' : '已开票'}}</span>
              <span class="iconfont iconjiantouarrow483"></span>
              <van-dropdown-menu>
                <van-dropdown-item v-model="status" :options="stateList" />
              </van-dropdown-menu>
            </div>
            <invoice-my :invoiceList="invoiceListMy"></invoice-my>
          </div>
        </van-list>
        <van-empty v-if="isEmpty" description="暂无发票"></van-empty>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import invoiceHb from '../../components/invoiceHb.vue'
import invoiceMy from '../../components/invoiceMy.vue'
import invoiceOrder from '../../components/invoiceOrder.vue'
export default {
  data() {
    return {
      tabs: [
        { id: 1, name: '订单待开票' },
        // { id: 2, name: '礼包待开票' },
        { id: 3, name: '我的发票' },
      ],
      active: 0,
      stateList: [
        { text: '全部', value: 0 },
        { text: '开票中', value: 1 },
        { text: '已开具', value: 10 },
      ],
      loading: false,
      finished: false,
      keys: 0,
      invoiceListRitual: [], // 开票订单
      invoiceListMy: [], // 数据R
      invoiceListOrder: [], // 数据order
      page: 0,
      status: 0, // 状态 0全部 1开票中 10已开票
      path: '',
    }
  },
  components: {
    invoiceMy,
    invoiceHb,
    invoiceOrder,
  },
  computed: {
    isEmpty() {
      let list = [
        this.invoiceListOrder || [],
        this.invoiceListRitual || [],
        this.invoiceListMy || [],
      ]
      return list[this.keys].length == 0
    },
  },

  mounted() {
    this.prohibitweixinShare()
    // 初始化
    if (
      this.path != '/my' &&
      this.path != '/' &&
      sessionStorage.getItem('invoice')
    ) {
      console.log('1111')
      this.active = JSON.parse(sessionStorage.getItem('invoice'))
      this.openKeyFg(JSON.parse(sessionStorage.getItem('invoice')))
    } else {
      console.log('222')
      // this.invoiceOrder()
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.path = from.path
      console.log(from)
    })
  },
  methods: {
    // 全选
    allCheckFg(e) {
      this.invoiceListOrder = this.invoiceListOrder.map((item) => {
        return {
          ...item,
          checked: e,
        }
      })
    },
    // 订单待开发票
    invoiceOrder() {
      console.log(this.page)
      let _this = this
      this.http('MemberInvoice.getStayOrderGoodsInvoice', {
        limit: 10,
        page: this.page,
      }).then((res) => {
        if (res.status == 200) {
          _this.loading = false
          let list = res.content.list.map((item) => {
            return {
              ...item,
              checked: false,
            }
          })
          _this.invoiceListOrder =
            _this.page == 1 ? list : [..._this.invoiceListOrder, ...list]
          _this.finished = _this.invoiceListOrder.length == res.content.count
        }
      })
    },

    // 礼包待开发票
    invoiceRitual() {
      let _this = this
      this.http('MemberInvoice.getStayOrderPackInvoice', {
        limit: 10,
        page: this.page,
      }).then((res) => {
        if (res.status == 200) {
          _this.loading = false
          _this.invoiceListRitual =
            _this.page == 1
              ? res.content.list
              : [..._this.invoiceListRitual, ...res.content.list]
          _this.finished = res.content.invoiceListRitual % 10 != 0
        }
      })
    },

    // 我的
    invoiceMy() {
      let _this = this
      this.http('MemberInvoice.getMyInvoiceList', {
        limit: 10,
        page: this.page,
        status: this.status,
      }).then((res) => {
        if (res.status == 200) {
          _this.loading = false
          _this.invoiceListMy =
            _this.page == 1
              ? res.content.list
              : [..._this.invoiceListMy, ...res.content.list]
          _this.finished = res.content.invoiceListMy % 10 != 0
          console.log(_this.finished)
        }
      })
    },

    // 切换模块
    openKeyFg(e) {
      console.log(e)
      console.log(this.keys)
      // if (e == this.keys) {
      //   return
      // }
      sessionStorage.setItem('invoice', e)
      this.keys = e
      this.invoiceListRitual = [] // 开票订单
      this.invoiceListMy = [] // 开票订单
      this.invoiceListOrder = [] // 开票订单
      this.loading = true
      this.finished = false
      this.page = 1
      this.keys == 0
        ? this.invoiceOrder()
        : // : this.keys == 1
          // ? this.invoiceRitual()
          this.invoiceMy()
    },
    // 加载更多
    moreLadFg() {
      console.log('333')
      this.page += 1
      this.keys == 0
        ? this.invoiceOrder()
        : this.keys == 1
        ? this.invoiceRitual()
        : this.invoiceMy()
    },
  },
  watch: {
    status: function () {
      this.page = 1
      this.loading = true
      this.finished = false
      this.invoiceListMy = [] // 开票订单
      this.invoiceMy()
    },
  },
}
</script>

<style lang="scss" scoped>
.n_tips {
  background: #fff2f3;
  border-radius: 14px;
  padding: 20px;
  margin-bottom: 20px;
}
.n_tips p {
  font-size: 24px;
  color: #f0240e;
}
.invoice {
  background: #f7f8fa;
  min-height: 100vh;
  .invoi-top {
    width: 100%;
    height: 88px;
    display: flex;
    background: #fff;
    position: fixed;
    top: 0;
    left: 0;
    div {
      width: 50%;
      font-size: 28px;
      font-weight: 400;

      color: #969799;
      line-height: 88px;
      position: relative;
      text-align: center;
    }
    div.key {
      color: #323233;
      font-weight: 500;
    }
    div.key::after {
      display: block;
      content: '';
      position: absolute;
      left: 50%;
      bottom: 0;
      transform: translate(-50%, 0);
      width: 80px;
      height: 6px;
      background: #ee0a24;
      border-radius: 3px;
    }
  }
}

// 发票
.invoice-scroll {
  text-align: right;
  padding-right: 30px;
  line-height: 80px;
  font-size: 28px;
  font-weight: 400;
  color: #969799;
  position: relative;
  span {
    margin-right: 24px;
  }
  .van-dropdown-menu {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 10;
  }
}
</style>

<style>
.invoice .van-dropdown-menu__bar {
  opacity: 0;
}
</style>